"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var environment_service_1 = require("@nw/ui-core-shared/services/environment.service");
var main_store_service_1 = require("@nw/ui-core-shared/store/main-store.service");
var DeadlerblockBidMessageComponent = (function () {
    function DeadlerblockBidMessageComponent(environmentService, window, mainStoreService) {
        this.environmentService = environmentService;
        this.window = window;
        this.mainStoreService = mainStoreService;
    }
    DeadlerblockBidMessageComponent.prototype.ngOnInit = function () { };
    return DeadlerblockBidMessageComponent;
}());
DeadlerblockBidMessageComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'nw-deadlerblock-bid-message',
                template: "<div *ngIf=\"allowBid && !isCompetitiveBid && (bidType === 'my' || bidType === 'update')\" class=\"db-bid-message-container\">\n  <p class=\"text-center mt-2\" [attr.data-a8n]=\"'db-' + bidType + '-bid-message'\" [ngClass]=\"{'text-success': bidType === 'my', 'text-danger': bidType === 'update'}\">\n\n    {{ (bidType === 'my' ? 'dealerBlockLayout.youAreHighestBidder' : 'dealerBlockLayout.youHaveBeenOutbid') | translate }}\n  </p>\n</div>",
                styles: [".db-bid-message-container {   display: block !important; }"]
            },] },
];
/** @nocollapse */
DeadlerblockBidMessageComponent.ctorParameters = function () { return [
    { type: environment_service_1.EnvironmentService, },
    { type: undefined, decorators: [{ type: core_1.Inject, args: ['windowObject',] },] },
    { type: main_store_service_1.MainStoreService, },
]; };
DeadlerblockBidMessageComponent.propDecorators = {
    'allowBid': [{ type: core_1.Input },],
    'isCompetitiveBid': [{ type: core_1.Input },],
    'bidType': [{ type: core_1.Input },],
};
exports.DeadlerblockBidMessageComponent = DeadlerblockBidMessageComponent;
//# sourceMappingURL=deadlerblock-bid-message.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/shared/deadlerblock-bid-message/deadlerblock-bid-message.component.js
// module id = L6sO
// module chunks = 0